import { useContext } from 'react';

import { isFilterableDataType } from '@atom/components/common/workOrdersFilters/fieldFilterUtilities';
import WorkOrderFieldFilterInput from '@atom/components/common/workOrdersFilters/WorkOrderFieldFilterInput';
import { FieldFilter } from '@atom/types/work';
import { isCascadingField } from '@atom/utilities/workOrderFieldUtilities';

import WorkOrdersFiltersContext, {
  AdditionalFieldFilters,
} from './WorkOrdersFiltersContext';

import classes from './filters.module.css';

const WorkTemplateWorkFieldsFilter = () => {
  const {
    areFiltersDisabled,
    filterForm,
    workOrderTemplate,
    updateFilterForm,
  } = useContext(WorkOrdersFiltersContext);

  const { workTemplateFields } = filterForm;

  const onFieldFilterChange = (updatedFilter: FieldFilter) =>
    updateFilterForm(
      'workTemplateFields',
      (current: AdditionalFieldFilters) => ({
        ...current,
        [updatedFilter.id]: updatedFilter,
      }),
    );

  return (
    <>
      {(workOrderTemplate?.fields || [])
        .filter(
          field =>
            !isCascadingField(field) && isFilterableDataType(field.dataType),
        )
        .map(field => (
          <div className={classes.filterContainer} key={field.id}>
            <WorkOrderFieldFilterInput
              field={field}
              fieldFilter={workTemplateFields[field.id]}
              onChange={onFieldFilterChange}
              disabled={areFiltersDisabled}
              dataCy={`workOrdersFilterWorkField-${field.title}`}
            />
          </div>
        ))}
    </>
  );
};

export default WorkTemplateWorkFieldsFilter;
